export const TIME_FILTERS_VALUES = {
    RecentNext: 'TimeFilter_RecentNext',
    Today: 'TimeFilter_Today',
    Tomorrow: 'TimeFilter_Tomorrow',
    ThisWeek: 'TimeFilter_ThisWeek',
    ThisMonth: 'TimeFilter_ThisMonth',
    NextWeek: 'TimeFilter_NextWeek',
    NextMonth: 'TimeFilter_NextMonth',
    Yesterday: 'TimeFilter_Yesterday',
    PreviousWeek: 'TimeFilter_PreviousWeek',
    PreviousMonth: 'TimeFilter_PreviousMonth',
    Custom: 'TimeFilter_Custom'
}